(function () {
'use strict';
var I18N = window.ODAVIA_CART_I18N || {};
var TIERS = I18N.tiers === true;
var SYMBOL = { EUR: '€', CHF: 'CHF ', GBP: '£', USD: '$', CAD: '$', NZD: '$', AUD: '$' };
function rroot() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
function addRoute() { return (window.theme && theme.routes && theme.routes.cartAdd) || (rroot() + 'cart/add.js'); }
function qsa(sel, ctx) { return [].slice.call((ctx || document).querySelectorAll(sel)); }
function reduced(){ return window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches; }
/* SHKRELI 3.8.3: money is formatted from the storefront's own Shopify money format.
   I18N.moneySample = {{ 1234567 | money }} rendered by Liquid for the active market currency,
   so JS output is identical to Liquid output (same prefix/suffix, separators and decimals). */
function buildShopifyFmt(sample) {
var m = String(sample || '').match(/^([^\d]*)(\d[\d.,'\s\u00a0\u202f\u2019]*\d)(.*)$/);
if (!m) return null;
var pre = m[1], num = m[2], suf = m[3], digits = num.replace(/\D/g, '');
var dec = 0, decSep = '', thSep = '';
if (digits === '1234567') { dec = 2; decSep = num.charAt(num.length - 3); }
else if (digits !== '12346' && digits !== '12345') return null;
var c2 = num.charAt(2); if (!/\d/.test(c2)) thSep = c2;
return function (cents) {
var neg = Number(cents) < 0; var c = Math.abs(Number(cents) || 0);
var v = dec ? (c / 100).toFixed(2) : String(Math.round(c / 100));
var parts = v.split('.');
var ip = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thSep);
return (neg ? '-' : '') + pre + ip + (dec ? decSep + parts[1] : '') + suf;
};
}
var shopifyFmt = buildShopifyFmt(I18N.moneySample);
function fmt(cents, currency) {
currency = currency || I18N.currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'ALL';
if (shopifyFmt && (!I18N.currency || currency === I18N.currency)) return shopifyFmt(cents);
var n = (Number(cents) || 0) / 100;
if (currency === 'ALL') {
return Math.round(n).toLocaleString('de-DE') + ' L';
}
var s = n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
var sym = SYMBOL[currency] || (currency + ' ');
return sym + s;
}
function escapeHtml(t) {
return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
});
}
function heading(q) {
var H = (I18N.h && I18N.h.length === 5) ? I18N.h : ['Përfito deri në 15% zbritje sasie','Edhe 1 produkt deri te zbritja e parë','5% u arrit – edhe 1 produkt deri te 10%','10% u arrit – edhe 1 produkt deri te 15%','15% u arrit – niveli maksimal i zbritjes'];
return H[Math.min(q, 4)];
}
function fillPct(q) { return [0, 5, 11, 44, 77][Math.min(q, 4)]; }
function achievedTier(q) { if (q >= 4) return 15; if (q >= 3) return 10; if (q >= 2) return 5; return 0; }
function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
var prevTier = null;
function celebrate(tier) {
var p = qs('[data-odavia-progress]'); if (!p) return;
var ms = p.querySelector('.odavia-progress__ms[data-p="' + tier + '"]'); if (!ms) return;
ms.classList.remove('is-celebrate'); void ms.offsetWidth; ms.classList.add('is-celebrate');
var strong = (tier === 15);
var ring = document.createElement('span'); ring.className = 'odavia-progress__ring'; ms.appendChild(ring);
var made = [ring];
var n = strong ? 4 : 3;
for (var i = 0; i < n; i++) {
var s = document.createElement('span'); s.className = 'odavia-spark';
var ang = Math.PI * 2 * (i / n) - Math.PI / 2;
var d = strong ? 28 : 22;
s.style.setProperty('--dx', Math.round(Math.cos(ang) * d) + 'px');
s.style.setProperty('--dy', Math.round(Math.sin(ang) * d) + 'px');
ms.appendChild(s); made.push(s);
void s.offsetWidth; s.classList.add('go');
}
setTimeout(function () { made.forEach(function (el) { if (el.parentNode) el.parentNode.removeChild(el); }); ms.classList.remove('is-celebrate'); }, strong ? 1300 : 900);
}
function renderProgress(count) {
if (!TIERS) return;
var p = qs('[data-odavia-progress]'); if (!p) return;
var h = qs('[data-odavia-progress-heading]', p);
if (h) { var nt = heading(count); if (h.textContent !== nt) { h.textContent = nt; if (!reduced()) { h.classList.remove('is-changed'); void h.offsetWidth; h.classList.add('is-changed'); } } }
var f = qs('[data-odavia-progress-fill]', p); if (f) f.style.width = fillPct(count) + '%';
var nextFound = false;
[].forEach.call(p.querySelectorAll('.odavia-progress__ms'), function (m) {
var pn = +m.getAttribute('data-p');
var isA = (pn === 5 && count >= 2) || (pn === 10 && count >= 3) || (pn === 15 && count >= 4);
var isNext = false;
if (!isA && !nextFound) { isNext = true; nextFound = true; }
m.classList.toggle('is-active', isA);
m.classList.toggle('is-next', isNext);
m.classList.toggle('is-locked', !isA && !isNext);
m.setAttribute('aria-label', pn + '% ' + (isA ? (I18N.tierAchieved || 'unlocked') : (isNext ? (I18N.tierNext || 'next level') : (I18N.tierLocked || 'locked'))));
});
var tier = achievedTier(count);
if (prevTier !== null && tier > prevTier && !reduced()) celebrate(tier);
prevTier = tier;
}
function renderEmpty(cart) {
var empty = !((cart && cart.item_count) > 0);
var d = document.getElementById('CartDrawer');
if (d) d.classList.toggle('odv-is-empty', empty);
}
function renderTotals(cart) {
qsa('[data-odavia-savings]').forEach(function (sav) {
var disc = cart.total_discount || 0;
if (disc > 0) {
sav.hidden = false;
var v = qs('[data-odavia-savings-value]', sav); if (v) v.textContent = '−' + fmt(disc, cart.currency);
var badge = qs('[data-odavia-savings-badge]', sav); var t = TIERS ? achievedTier(cart.item_count || 0) : 0;
if (badge) { if (t > 0) { badge.hidden = false; badge.textContent = t + '%'; } else { badge.hidden = true; } }
} else { sav.hidden = true; }
});
qsa('[data-odavia-checkout-total]').forEach(function (ct) { ct.textContent = (cart.item_count || 0) > 0 ? '• ' + fmt(cart.total_price, cart.currency) : ''; });
qsa('.cart-link__bubble').forEach(function (b) { b.classList.toggle('cart-link__bubble--visible', (cart.item_count || 0) > 0); });
}
function compactDiscount(row, line, cart) {
if (!TIERS) return;
var d = row.querySelector('small.cart__discount');
if (d && line.total_discount > 0) {
var txt = achievedTier(cart.item_count) + (I18N.discount || '% zbritje · −') + fmt(line.total_discount, cart.currency);
if (d.textContent.trim() !== txt) d.textContent = txt;
}
}
function decorateRows(cart) {
var wrap = qs('#CartDrawer [data-products]');
if (wrap) {
(cart.items || []).forEach(function (line) {
var row = wrap.querySelector('.cart__item[data-key="' + line.key + '"]'); if (!row) return;
var host = row.querySelector('.cart__image') || row.querySelector('.cart__item-title');
if (host) {
var badge = row.querySelector('.odavia-qty-badge');
if (!badge) { badge = document.createElement('span'); badge.className = 'odavia-qty-badge'; host.insertBefore(badge, host.firstChild); }
if (badge.getAttribute('data-q') !== String(line.quantity)) {
badge.setAttribute('data-q', line.quantity);
badge.textContent = line.quantity + '×';
badge.setAttribute('aria-label', line.quantity + ' ' + (I18N.selected || 'Stück ausgewählt'));
if (!reduced()) { badge.classList.remove('is-bump'); void badge.offsetWidth; badge.classList.add('is-bump'); }
}
}
compactDiscount(row, line, cart);
var rem = row.querySelector('.cart__remove a');
if (rem) { rem.setAttribute('aria-label', I18N.removeLabel || 'Produkt entfernen'); rem.setAttribute('role', 'button'); rem.setAttribute('data-odv-remove', line.key); if (!rem.querySelector('svg')) rem.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>'; }
});
}
var pageWrap = qs('#CartPageForm [data-products]');
if (pageWrap) {
(cart.items || []).forEach(function (line) {
var row = pageWrap.querySelector('.cart__item[data-key="' + line.key + '"]'); if (!row) return;
compactDiscount(row, line, cart);
});
}
}
function apply(cart) {
if (cart && cart.currency) I18N.currency = cart.currency;
renderEmpty(cart);
renderProgress(cart.item_count || 0);
renderTotals(cart);
decorateRows(cart);
maybeReco(cart);
}
var busy = false;
function refresh() {
if (busy) return; busy = true;
fetch(rroot() + 'cart.js', { headers: { Accept: 'application/json' } })
.then(function (r) { return r.json(); })
.then(function (c) { apply(c); })
.catch(function () {})
.then(function () { busy = false; });
}
var timer;
function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 150); }
/* SHKRELI 3.8.3: explicit remove control inside the cart drawer (AJAX, no page reload) */
document.addEventListener('click', function (e) {
var a = e.target.closest && e.target.closest('#CartDrawer .cart__remove a');
if (!a) return;
e.preventDefault();
if (a.getAttribute('aria-busy') === 'true') return;
var row = a.closest('.cart__item');
var key = a.getAttribute('data-odv-remove') || (row && row.getAttribute('data-key'));
if (!key) return;
a.setAttribute('aria-busy', 'true');
if (row) row.style.opacity = '.45';
fetch(rroot() + 'cart/change.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
body: JSON.stringify({ id: key, quantity: 0 })
})
.then(function (r) { if (!r.ok) throw new Error('remove-failed'); return r.json(); })
.then(function (cart) {
apply(cart);
try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (x) {}
try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } })); } catch (x) {}
schedule();
})
.catch(function () { if (row) row.style.opacity = ''; a.removeAttribute('aria-busy'); schedule(); });
});
var recoLoadedFor = null, recoIndex = 0, recoCount = 0;
function maybeReco(cart) {
var wrap = qs('[data-odavia-reco]'); if (!wrap) return;
if (!cart.items || !cart.items.length) { wrap.hidden = true; recoLoadedFor = null; return; }
var baseId = cart.items[0].product_id;
if (recoLoadedFor === baseId) return;
recoLoadedFor = baseId;
var inCart = {}; cart.items.forEach(function (i) { inCart[i.product_id] = 1; });
fetch(rroot() + 'recommendations/products.json?product_id=' + baseId + '&limit=10&intent=related', { headers: { Accept: 'application/json' } })
.then(function (r) { return r.json(); })
.then(function (d) {
var list = (d.products || []).filter(function (p) { return !inCart[p.id] && p.available; }).slice(0, 6);
buildReco(wrap, list);
})
.catch(function () { wrap.hidden = true; recoLoadedFor = null; });
}
function buildReco(wrap, list) {
var track = qs('[data-odavia-reco-track]', wrap);
if (!track || !list.length) { wrap.hidden = true; return; }
track.innerHTML = list.map(function (p) {
var vs = p.variants || [];
var avail = vs.filter(function (x) { return x.available; });
var v = avail[0] || null;
var img = p.featured_image || (p.images && p.images[0]) || '';
var price = (p.price != null) ? fmt(p.price) : '';
var picker = '';
if (v && vs.length > 1) {
picker = '<select class="odavia-reco__variant" data-odavia-variant aria-label="' + escapeHtml(I18N.variant || 'Variante') + '">' +
vs.map(function (x) {
return '<option value="' + x.id + '"' + (x.available ? '' : ' disabled') + ((x.id === v.id) ? ' selected' : '') + '>' + escapeHtml(x.title) + '</option>';
}).join('') + '</select>';
}
return '<div class="odavia-reco__card" data-odavia-reco-card><div class="odavia-reco__row">' +
(img ? '<img class="odavia-reco__img" src="' + img + '" alt="" loading="lazy">' : '') +
'<div class="odavia-reco__info"><p class="odavia-reco__name">' + escapeHtml(p.title) + '</p>' +
'<p class="odavia-reco__price">' + price + '</p></div></div>' +
picker +
'<button type="button" class="odavia-reco__btn" data-odavia-add' + (v ? ' data-vid="' + v.id + '"' : ' disabled') + '>' +
(v ? (I18N.add || 'Hinzufügen') : (I18N.unavailable || 'Nicht verfügbar')) + '</button>' +
'<p class="odavia-reco__error" data-odavia-reco-error hidden></p></div>';
}).join('');
recoIndex = 0; recoCount = list.length;
wrap.hidden = false; positionReco(wrap);
}
function positionReco(wrap) {
var track = qs('[data-odavia-reco-track]', wrap); if (!track) return;
track.style.transform = 'translateX(-' + (recoIndex * 100) + '%)';
var prev = qs('[data-odavia-reco-prev]', wrap), next = qs('[data-odavia-reco-next]', wrap);
if (prev) prev.disabled = recoIndex <= 0;
if (next) next.disabled = recoIndex >= recoCount - 1;
var show = recoCount > 1;
if (prev) prev.style.visibility = show ? '' : 'hidden';
if (next) next.style.visibility = show ? '' : 'hidden';
}
document.addEventListener('click', function (e) {
var wrap = qs('[data-odavia-reco]'); if (!wrap) return;
if (e.target.closest('[data-odavia-reco-prev]')) { if (recoIndex > 0) { recoIndex--; positionReco(wrap); } }
else if (e.target.closest('[data-odavia-reco-next]')) { if (recoIndex < recoCount - 1) { recoIndex++; positionReco(wrap); } }
});
document.addEventListener('click', function (e) {
var btn = e.target.closest && e.target.closest('[data-odavia-add]');
if (!btn) return;
e.preventDefault();
if (btn.disabled || btn.getAttribute('data-odavia-busy') === '1') return;
var card = btn.closest('[data-odavia-reco-card]');
var sel = card && card.querySelector('[data-odavia-variant]');
var vid = sel ? sel.value : btn.getAttribute('data-vid');
if (!vid) return;
var err = card && card.querySelector('[data-odavia-reco-error]');
if (err) err.hidden = true;
btn.setAttribute('data-odavia-busy', '1');
btn.disabled = true;
btn.setAttribute('aria-busy', 'true');
btn.textContent = I18N.adding || 'Wird hinzugefügt …';
fetch(addRoute(), {
method: 'POST',
headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
body: JSON.stringify({ id: parseInt(vid, 10) || vid, quantity: 1 })
})
.then(function (r) { if (!r.ok) throw new Error('add-failed'); return r.json(); })
.then(function (item) {
btn.removeAttribute('aria-busy');
btn.textContent = I18N.added || 'Hinzugefügt';
try { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item } })); } catch (x) {}
try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (x) {}
recoLoadedFor = null;
schedule();
setTimeout(function () {
btn.textContent = I18N.add || 'Hinzufügen';
btn.disabled = false;
btn.removeAttribute('data-odavia-busy');
}, 1200);
})
.catch(function () {
btn.removeAttribute('aria-busy');
btn.textContent = I18N.add || 'Hinzufügen';
btn.disabled = false;
btn.removeAttribute('data-odavia-busy');
if (err) {
err.textContent = I18N.error || 'Das Produkt konnte nicht hinzugefügt werden. Bitte versuchen Sie es erneut.';
err.hidden = false;
}
});
});
function initDrawerLocalization() {
if (!(window.theme && typeof theme.Disclosure === 'function')) return;
var nd = document.getElementById('NavDrawer');
if (!nd || nd.getAttribute('data-odavia-disclosure') === '1') return;
var els = nd.querySelectorAll('[data-disclosure-locale], [data-disclosure-currency]');
if (!els.length) return;
nd.setAttribute('data-odavia-disclosure', '1');
[].forEach.call(els, function (d) { try { new theme.Disclosure(d); } catch (e) {} });
}
function observe() {
initDrawerLocalization();
var drawer = document.getElementById('CartDrawer');
if (drawer) {
var products = drawer.querySelector('[data-products]');
if (products) new MutationObserver(schedule).observe(products, { childList: true, subtree: true });
var subtotal = drawer.querySelector('[data-subtotal]');
if (subtotal) new MutationObserver(schedule).observe(subtotal, { childList: true, characterData: true, subtree: true });
new MutationObserver(schedule).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
new MutationObserver(function (muts) { for (var i = 0; i < muts.length; i++) { if (muts[i].attributeName === 'class' && /drawer--is-open/.test(drawer.className) !== /drawer--is-open/.test(muts[i].oldValue || '')) { schedule(); return; } } }).observe(drawer, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
}
var pageForm = document.getElementById('CartPageForm');
if (pageForm) {
var pProducts = pageForm.querySelector('[data-products]');
if (pProducts) new MutationObserver(schedule).observe(pProducts, { childList: true, subtree: true });
var pSubtotal = pageForm.querySelector('[data-subtotal]');
if (pSubtotal) new MutationObserver(schedule).observe(pSubtotal, { childList: true, characterData: true, subtree: true });
}
if (!drawer && !pageForm) return;
['cart:updated', 'cart:build', 'cart:refresh', 'ajaxCart:updated', 'ajaxProduct:added'].forEach(function (ev) { document.addEventListener(ev, schedule); });
document.addEventListener('click', function (e) {
if (e.target.closest && e.target.closest('a[href$="/cart"], a[href*="/cart?"], .cart-link, [data-drawer="cart"], #CartToggle, .js-drawer-open-cart, .js-drawer-open-button-right')) setTimeout(schedule, 180);
});
refresh();
}
if (document.readyState !== 'loading') observe();
else document.addEventListener('DOMContentLoaded', observe);
})();
